import { useState, useCallback } from "react";

import { LendingStrategyPagination, StrategyExpandedInfo, StrategySortType } from "@bridgesplit/abf-react";
import { SortDirection } from "@bridgesplit/utils";

import { getPrincipalMints, useChunkedPaginationController } from "./shared";

const DEFAULT_PAGE_SIZE = 5;

export function useLenderStrategiesPagination() {
    const [showArchived, setShowArchived] = useState<boolean>(false); //showArchived

    const [principalMint, setPrincipalMint] = useState<string | undefined>(undefined);
    const [sortDirection, setSortDirection] = useState<SortDirection>(SortDirection.Desc);
    const [sortType, setSortType] = useState<StrategySortType>(StrategySortType.NetAssetValue);

    const chunkedPagination = useChunkedPaginationController<StrategyExpandedInfo, LendingStrategyPagination>(
        {
            userAddress: undefined,
            principalMints: getPrincipalMints(principalMint),
            addresses: [],
            showArchived,
            sortDirection,
            sortType
        },
        DEFAULT_PAGE_SIZE
    );

    const reset = useCallback(() => {
        setShowArchived(false);
        setPrincipalMint(undefined);
        chunkedPagination.resetPagination();
    }, [chunkedPagination]);

    return {
        ...chunkedPagination, //Backend pagination params
        params: chunkedPagination.clientPagination, //Client pagination params
        setShowArchived,
        setPrincipalMint,
        setSortDirection,
        setSortType,
        reset
    };
}
